import { debounce } from 'data/function';
import { v4 as uuid } from 'uuid';
import { BuilderContentType } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/BuilderContentType';
import './Category.scss';
import * as styles from './category.module.scss';
import { CONTENT_TYPES } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/InputController';
import { AttendanceConstants } from '../../AttendanceConstants';
export class CategoryController {
    static $inject = ['SegmentService', 'application', 'BuilderContentService', 'RepliesService2', '$stateParams', 'ngToast', '$translate', 'SavingService', '$timeout', 'PermissionsService', 'DeskConfigurationService'];
    constructor(SegmentService, application, BuilderContentService, RepliesService2, $stateParams, ngToast, $translate, SavingService, $timeout, PermissionsService, DeskConfigurationService) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.application = application;
        this.BuilderContentService = BuilderContentService;
        this.RepliesService2 = RepliesService2;
        this.$stateParams = $stateParams;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.SavingService = SavingService;
        this.$timeout = $timeout;
        this.PermissionsService = PermissionsService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.newCategory = false;
        this.categoryName = this.$translate.instant('repliesCategoryPage.title.none');
        this.replies = [];
        this.pageStatus = 'saved';
        this.repeatedTitlesErrorMsg = '';
        this.changeCategoryName = async (event) => {
            this.categoryName = event?.detail?.value.trim() ?? this.$translate.instant('repliesCategoryPage.title.none');
            this.debouncedSave();
        };
    }
    sortReplies(a, b) {
        try {
            const textA = a.name.toLowerCase();
            const textB = b.name.toLowerCase();
            if (textA < textB) {
                return -1;
            }
            if (textA > textB) {
                return 1;
            }
            return 0;
        }
        catch (err) {
            console.error(err);
            return 0;
        }
    }
    async $onInit() {
        this.styles = styles;
        this.hasWritingPermission = await this.PermissionsService.hasPermissions('write', 'desk');
        this.debouncedSave = debounce(this.saveForm.bind(this), 1000);
        this.repeatedTitlesErrorMsg = await this.$translate('utils.errorMsg.132');
        this.contentTypes = CONTENT_TYPES.map(type => ({
            label: type,
            value: type,
        }));
        this.addNewBlockData = {
            text: this.$translate.instant('modules.application.detail.growth.scheduler.wizard.rawContent.addType'),
        };
        if (this.$stateParams.id) {
            this.categoryid = this.$stateParams.id;
            const { items } = await this.RepliesService2.getCategoryReplies(this.categoryid);
            items.sort(this.sortReplies);
            this.categoryName = items[0].category;
            const mapResourceToReply = item => {
                const id = uuid();
                return {
                    ...item,
                    documentId: id,
                    component: {
                        document: {
                            id: id,
                            type: item.type,
                            content: item.isDynamicContent
                                ? item.document
                                : JSON.parse(item.document),
                            isEditing: false,
                        },
                        position: 'left',
                        editable: this.hasWritingPermission,
                        deletable: this.hasWritingPermission,
                        'on-save': _ => {
                            this.saveForm();
                        },
                        'on-deleted': d => {
                            this.deleteReply(d);
                        },
                    },
                };
            };
            this.replies = items.map(mapResourceToReply);
        }
        else {
            this.categoryid = uuid();
            this.newCategory = true;
        }
        this.isCallsVoiceInboundEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.CALLS_VOICE_INBOUND_ENABLED);
    }
    saveForm() {
        if (this.replyForm.$valid) {
            if (!this.validateReplyNames()) {
                this.ngToast.danger(this.repeatedTitlesErrorMsg);
                return;
            }
            this.saveCategory();
        }
    }
    validateReplyNames() {
        const repliesNames = this.replies.map(r => r.name);
        const repliesNameSet = new Set(repliesNames);
        return (repliesNames.length === repliesNameSet.size ||
            repliesNames.length <= 1);
    }
    validateCategoryExistence() {
        return this.replies.length > 0 || this.newCategory;
    }
    deleteCategory() {
        if (!this.hasWritingPermission) {
            return;
        }
        return this.RepliesService2.delete(this.categoryid);
    }
    async saveCategory() {
        if (!this.hasWritingPermission) {
            return;
        }
        this.SavingService.startSaving();
        this.pageStatus = 'saving';
        try {
            if (!this.validateCategoryExistence()) {
                await this.deleteCategory();
            }
            else if (this.replies.length > 0) {
                const category = this.categoryName
                    ? this.categoryName
                    : this.$translate.instant('repliesCategoryPage.title.none');
                const replies = this.replies.map(x => ({
                    id: this.categoryid,
                    category,
                    name: x.name,
                    type: x.component.document.type,
                    document: x.isDynamicContent
                        ? x.component.document.content
                        : JSON.stringify(x.component.document.content),
                    isDynamicContent: x.isDynamicContent,
                }));
                await this.RepliesService2.save(replies, this.categoryid);
            }
        }
        catch (error) {
            this.ngToast.danger(error.message);
        }
        finally {
            this.$timeout(() => {
                this.SavingService.stopSaving();
                this.pageStatus = 'saved';
            }, 500);
        }
    }
    deleteReply(document) {
        this.replies = this.replies.filter(x => x.documentId != document.id);
        this.saveCategory();
    }
    async addNewReply(type) {
        this.createAddReplyTrack();
        const contentTemplate = this.BuilderContentService.getContentTemplate(type);
        const name = '';
        if (this.isNameRepeated(name)) {
            this.ngToast.danger(this.repeatedTitlesErrorMsg);
            return;
        }
        const id = uuid();
        const newReply = {
            component: {
                document: {
                    ...contentTemplate,
                    id: id,
                },
                position: 'left',
                editable: true,
                editing: false,
                deletable: true,
                'on-save': d => {
                    this.saveForm();
                },
                'on-deleted': d => {
                    this.deleteReply(d);
                },
            },
            documentId: id,
            id: this.categoryid,
            category: this.categoryName,
            name: name,
            type: contentTemplate.type,
            isDynamicContent: (type === BuilderContentType.RawContent),
            isEditing: true,
        };
        this.replies = [newReply, ...this.replies];
    }
    isNameRepeated(itemName) {
        return this.replies.some(i => i.name === itemName);
    }
    createAddReplyTrack() {
        this.SegmentService.createBotTrack('helpdesk-custom-reply-added', this.application);
    }
    addNewState({ newOption: { label } }, component) {
        component.document.type = label;
        this.contentTypes = [...this.contentTypes, { label, value: label }];
        this.contentTypes.sort();
    }
    saveFormWithDynamicReply(reply) {
        // Add " on beginning and ending to plain text content
        if (reply.type === 'text/plain') {
            reply.content = `"${reply.content}"`;
        }
        if (reply.type.includes('json')) {
            try {
                JSON.parse(reply.content);
            }
            catch (e) {
                this.ngToast.danger(this.$translate.instant('repliesCategoryPage.errors.invalidJson'));
                return;
            }
        }
        reply.isEditing = false;
        reply.component.document.type = reply.type;
        reply.component.document.content = reply.content;
        this.saveForm();
    }
    cancelEditDynamicReply(reply) {
        reply.isEditing = false;
        reply.type = undefined;
        reply.content = undefined;
    }
    editDynamicReply(reply) {
        reply.isEditing = true;
        reply.type = reply.component.document.type;
        reply.content = reply.component.document.content;
        // Remove " from beginning and ending on plain text content
        if (reply.type === 'text/plain') {
            reply.content = reply.content.slice(1, -1);
        }
    }
    deleteDynamicReply(reply) {
        reply.isEditing = false;
        this.deleteReply(reply.component.document);
    }
}
CategoryController.$inject = ['SegmentService', 'application', 'BuilderContentService', 'RepliesService2', '$stateParams', 'ngToast', '$translate', 'SavingService', '$timeout', 'PermissionsService', 'DeskConfigurationService'];
